import axios from 'axios';

export const resendVerificationEmailInternal = (email) => {
  return axios.post('/auth/email/resend/verification', {
    email,
    isAccountVerifyOnly: true,
  });
};
